<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.5.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Like" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#50739d;}
	.st1{fill:#FFFFFF;}
</style>
<circle class="st0" cx="256" cy="256" r="256"/>
<path class="st1" d="M293.4,110.6c16.9,3.4,28,19.9,24.6,36.8l-1.5,7.4c-3.5,17.4-9.8,33.9-18.8,49h93.8c17.3,0,31.3,14,31.3,31.3
	c0,12.1-6.8,22.5-16.9,27.8c7.1,5.7,11.7,14.5,11.7,24.4c0,15.2-10.9,28-25.3,30.7c2.9,4.8,4.5,10.3,4.5,16.2
	c0,13.9-9.1,25.7-21.6,29.7c0.5,2.2,0.7,4.4,0.7,6.8c0,17.3-14,31.3-31.3,31.3h-63.5c-12.4,0-24.4-3.6-34.7-10.5l-25.1-16.7
	c-17.4-11.6-27.8-31.1-27.8-52.1v-25v-31.3v-16.2c0-19,8.7-36.9,23.5-48.9l4.8-3.8c17.3-13.8,29.1-33.2,33.4-54.9l1.5-7.4
	C260,118.3,276.5,107.3,293.4,110.6L293.4,110.6z M110,214.3h41.7c11.5,0,20.9,9.3,20.9,20.9v146c0,11.5-9.3,20.9-20.9,20.9H110
	c-11.5,0-20.9-9.3-20.9-20.9v-146C89.2,223.6,98.5,214.3,110,214.3z"/>
</svg>
